import React from "react";

function BalanceRow({name, value}) {
    return (
        <div style={{width: "100%", paddingTop: 20, display: "flex", justifyContent: "space-between"}}>
            <span style={{color: "var(--grey0)"}}>{name}</span>
            <span style={{fontWeight: "bold"}}>{value}</span>
        </div>
    );
}

export default BalanceRow;